module.exports = __webpack_public_path__ + "assets/img/Level2高速行情.f704a50a.png";